import { render, staticRenderFns } from "./ProductWithdraw.vue?vue&type=template&id=d98e1780&scoped=true"
import script from "./ProductWithdraw.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductWithdraw.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductWithdraw.vue?vue&type=style&index=0&id=d98e1780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98e1780",
  null
  
)

export default component.exports